import { useEffect } from 'react'
import { toast } from 'react-toastify'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClipboard, faUser } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, Text, UserProfileImage,
} from '@domain-group/suit-theme'
import { useSetState } from '@domain-group/react-hooks'

import copyToClipboard from '@functions/copyToClipboard'

import type { ImageModel, UserModel } from '@models/types'
import type { BulkShareArtworksPayload } from '@hooks/useBulkShareArtworks'

const defaultState = {
  presignedUrl: '',
}

interface UserProps {
  artworkReviewUrl: string,
  callbacks: {
    prepareUrl: (presignedUrl: string) => string,
    presignUrl: () => ReturnType<BulkShareArtworksPayload['callbacks']['presignUrl']>,
  },
  image: ImageModel,
  user: UserModel,
}

const User = (props: UserProps) => {
  const {
    artworkReviewUrl,
    image,
    user: {
      email,
      id,
      full_name,
    },
  } = props

  const [state, setState] = useSetState(defaultState)
  const { presignedUrl } = state

  // Currently not doing this but may want to change in future
  // useEffect(() => {
  //   if (id){
  //     presignUrl().then((result) => {
  //       const { data, errors, success } = result

  //       if (!success && errors){
  //         toast.warning(errors[0])
  //         return
  //       }

  //       const { url } = data

  //       setState({ presignedUrl: url })
  //     })
  //   }
  // }, [id])

  // const reviewUrl = prepareUrl(presignedUrl)

  return (
    <Box flexDirection="column" marginTop="large">
      <Box>
        <UserProfileImage imageUrl={image.square_url}>
          <FontAwesomeIcon icon={faUser} />
        </UserProfileImage>

        <Box flexDirection="column" justifyContent="center" marginLeft="medium">
          <Text fontSize="small">{full_name}</Text>
          <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="small">
            {email}
          </Text>
        </Box>
      </Box>

      <Box marginTop="large">
        <input readOnly type="text" value={artworkReviewUrl} style={{ marginBottom: 0 }} />

        <Button
          buttonStyle="secondaryEdit"
          icon={<FontAwesomeIcon icon={faClipboard} />}
          marginLeft="medium"
          onClick={() => copyToClipboard(artworkReviewUrl)}
          size="medium"
          width="auto"
        />
      </Box>
    </Box>
  )
}

export default User
